var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Save Draft"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 7.21156V20.5H3.5V3.50003H16.7884L20.5 7.21156ZM19 7.85001L16.15 5.00001H4.99997V19H19V7.85001ZM11.9977 17.2692C12.6915 17.2692 13.282 17.0263 13.7692 16.5407C14.2564 16.055 14.5 15.4653 14.5 14.7715C14.5 14.0777 14.2571 13.4872 13.7715 13C13.2858 12.5128 12.6961 12.2693 12.0023 12.2693C11.3084 12.2693 10.7179 12.5121 10.2308 12.9978C9.74359 13.4834 9.5 14.0732 9.5 14.767C9.5 15.4608 9.74283 16.0512 10.2285 16.5384C10.7142 17.0256 11.3039 17.2692 11.9977 17.2692ZM6.38463 9.88461H14.5961V6.38466H6.38463V9.88461ZM4.99997 7.85001V19V5.00001V7.85001Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/icon-save.15291c9000536d9a1ed6c6b8cce87bab.svg";
export { ForwardRef as ReactComponent };